import { Typography } from '@euler/app/components/typography';
import { useTaskHeaderMetrics } from '@euler/app/flows/task/functions/useTaskHeaderMetrics';
import { AppNavParams } from '@euler/app/Routes';
import { Colors } from '@euler/components/Colors';
import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useOnNavigateBack } from '@euler/functions/useOnNavigateBack';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { LinearGradient } from 'expo-linear-gradient';
import React, { memo, ReactNode } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import {} from 'react-native-redash';
import { TaskHeaderMoreButton } from './HeaderOptions';
import { TaskNavBarSpinner } from './NavBarSpinner';

export const StaticTaskNavBar = memo(
  ({
    title,
    accessoryText,
    titleLoadingIndicator,
    rightOptions,
    onShowActions,
  }: {
    title: string;
    titleLoadingIndicator?: boolean;
    accessoryText?: string;
    rightOptions?: () => ReactNode;
    onShowActions?: () => void;
  }) => {
    const navigation = useNavigation<StackNavigationProp<AppNavParams>>();
    const { rpx } = useResponsiveContext();
    const { navBarHeight, safeAreaInsets } = useTaskHeaderMetrics();

    const onBackPress = useOnNavigateBack(() => {
      if (navigation.canGoBack()) {
        navigation.goBack();
      } else {
        navigation.replace('Main', {});
      }
    });

    return (
      <View
        css={`
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          height: ${navBarHeight}px;
          padding-top: ${safeAreaInsets.top}px;
          justify-content: space-between;
          align-items: center;
          flex-direction: row;
          padding-left: ${rpx(15)}px;
          padding-right: ${rpx(16)}px;
          z-index: 10;
        `}
      >
        <View style={[StyleSheet.absoluteFill]}>
          <LinearGradient
            start={{ x: 0, y: 0.5 }}
            end={{ x: 1, y: 1 }}
            colors={['#006be4', '#5ba0e0']}
            locations={[0.335, 1]}
            style={StyleSheet.absoluteFill}
          />
        </View>
        <View
          css={`
            padding-top: ${safeAreaInsets.top}px;
            justify-content: center;
            align-items: center;
            flex-direction: row;
          `}
          style={[StyleSheet.absoluteFill]}
        >
          <TaskNavBarSpinner animating={false} offsetX={-3} />
          <Typography.Label
            medium
            size={rpx(20)}
            color="white"
            numberOfLines={0}
          >
            {title}
          </Typography.Label>
          <TaskNavBarSpinner
            animating={titleLoadingIndicator === true}
            offsetX={3}
          />
        </View>
        <View
          css={`
            position: absolute;
            left: 0px;
            right: 0px;
            bottom: 0px;
            height: ${navBarHeight - safeAreaInsets.top}px;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
            padding-left: ${rpx(15)}px;
            padding-right: ${rpx(16)}px;
          `}
        >
          <TouchableOpacity onPress={onBackPress}>
            <Icon
              name="arrow-back-circle-outline"
              size={rpx(32)}
              color="white"
            />
          </TouchableOpacity>
          {rightOptions != null ? (
            rightOptions()
          ) : onShowActions != null ? (
            <TaskHeaderMoreButton color="white" onPress={onShowActions} />
          ) : null}
          {accessoryText != null && (
            <View>
              <Typography.Label
                light
                size={rpx(11)}
                color={Colors.White7_5}
                css={`
                  text-align: center;
                `}
              >
                {accessoryText}
              </Typography.Label>
            </View>
          )}
        </View>
      </View>
    );
  },
);
